import { useEffect, forwardRef, useState } from "react";
import "./About.css";
import image from "../../images/sections/about.jpg";
import AOS from "aos";

const About = forwardRef((props, ref) => {
  const [thirdParagraphDisplay, setThirdParagraphDisplay] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);

  return (
    <div ref={ref} className="about" id={2}>
      <div
        className="about-heading"
        data-aos="zoom-out-down"
        data-aos-once="true"
      >
        <span className="title-section">Nosotros</span>
      </div>
      <div className="about-container">
        <div className="about-img" data-aos="zoom-in-left" data-aos-once="true">
          <img alt="" src={image} />
        </div>
        <div
          className="about-content"
          data-aos="fade-right"
          data-aos-once="true"
        >
          <p>
            <strong>¿Quienes somos?</strong>
          </p>
          <p className="mt-2">
            Somos un equipo de abogados especializados en derecho financiero, con amplia experiencia en la negociación de deudas bancarias y financieras. Ayudamos a personas como vos a negociar, refinanciar o cancelar sus deudas, defendiendo tus derechos y buscando siempre la mejor solución legal para que puedas volver a empezar y reinsertarte en el sistema financiero.
          </p>
          <p className="mt-4">
            <strong>¿Tenés deudas y no sabés cómo salir o por donde empezar?</strong>
          </p>
          <p className="mt-2">
            En Argentina, miles de personas enfrentan a diario el peso de las deudas con bancos, tarjetas de crédito o financieras. Muchos se sienten solos, acosados por llamados constantes, intereses impagables y sin una salida clara.
          </p>
          <p className="mt-2">
            <strong>No estás solo. Estamos para ayudarte.</strong>
          </p>
        </div>
      </div>
    </div>
  );
});

export default About;
